import React from "react";
import { CreatePageFinalize } from "./CreatePageFinalize";

type Props = React.ComponentProps<typeof CreatePageFinalize>;

export const CreatePageV2Finalize: React.FC<Props> = (props) => {
  const { UNSAFE_finalizeLabel = { text: "Finalize" } } = props;

  return <CreatePageFinalize {...props} UNSAFE_finalizeLabel={UNSAFE_finalizeLabel} />;
};
